import { useQuery } from '@tanstack/react-query';
import { useRecipient } from '../components/settings/shared/settings-queries';
import { API_BASE } from './api-base';

/** The shared employee release is conducted by the authenticated server. No client override. */
export async function fetchChatsEnabled(): Promise<boolean> {
  const controller = new AbortController();
  const timeout = setTimeout(() => controller.abort(), 3500);
  try {
    const response = await fetch(`${API_BASE}/api/flags/chats`, {
      credentials: 'include', signal: controller.signal,
    });
    return response.ok && (await response.json()) === true;
  } catch {
    return false;
  } finally {
    clearTimeout(timeout);
  }
}

/** One cached request per account, shared by the menu, layout and transcript. */
export function useChatsGate(): { enabled: boolean; resolved: boolean } {
  const recipient = useRecipient();
  const owner = recipient.data?.email && recipient.data.metaSiteId
    ? JSON.stringify([recipient.data.email, recipient.data.metaSiteId]) : null;
  const query = useQuery({
    queryKey: ['chats-flag', owner], queryFn: fetchChatsEnabled, enabled: !!owner,
    staleTime: 30_000, refetchOnWindowFocus: true, retry: false,
  });
  return { enabled: !!owner && query.data === true,
    resolved: owner ? query.isSuccess || query.isError : !recipient.isLoading };
}
